import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="unsaved-changes"
export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.dirtyScopes = new Set();
    this._onBeforeVisit = this.onBeforeVisit.bind(this);
    this._onBeforeUnload = this.onBeforeUnload.bind(this);
    this._onSyncReload = () => { this.dirtyScopes.clear() };

    window.addEventListener("beforeunload", this._onBeforeUnload);
    document.addEventListener("turbo:before-visit", this._onBeforeVisit);
    window.addEventListener("pwa:before-sync-reload", this._onSyncReload);
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this._onBeforeVisit)
    window.removeEventListener("beforeunload", this._onBeforeUnload)
    window.removeEventListener("pwa:before-sync-reload", this._onSyncReload)
  }

  get isDirty() {
    return this.dirtyScopes.size > 0;
  }

  markDirty(event) {
    this.dirtyScopes.add(this._scopeFor(event));
  }

  markClean(event) {
    this.dirtyScopes.delete(this._scopeFor(event));
  }

  onBeforeVisit(event) {
    if (!this.isDirty) return

    if (!confirm("データはまだ保存されていません。保存せずに他のページへ移動しますか？")) {
      event.preventDefault()
    }
  }

  onBeforeUnload(event) {
    if (!this.isDirty) return;
    event.preventDefault();
    event.returnValue = "";
  }

  submit() {
    this.dirtyScopes.clear();
  }

  // Resolve a stable scope key for the event. Inputs/clicks inside a
  // performance row are scoped to that row so cancelling one row does not
  // clear dirty state from other rows; everything else falls back to the
  // form-level bucket.
  _scopeFor(event) {
    const target = event?.target;
    const wrapper = target?.closest?.("[data-performance-wrapper]");
    return wrapper || "__form__";
  }
}
